/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class AdminService {

    /**
     * List all users
     * @result any
     * @throws ApiError
     */
    public static async adminControllerFindAll(): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/admin/users/list-all`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * List all pending users
     * @result any
     * @throws ApiError
     */
    public static async adminControllerFindAllPending(): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/admin/users/list-pending`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Verify a user
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerVerify(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/users/verify/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Reject a user
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerReject(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/users/reject/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * block a user
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerBlock(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/users/block/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * unblock a user
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerUnblock(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/users/unblock/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * delete a user
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerDeleteUser(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/users/delete/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * delete an artwork
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async adminControllerDeleteArtwork(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/admin/artworks/delete/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get expenses
     * @result any
     * @throws ApiError
     */
    public static async adminControllerGetExpenses(): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/admin/expenses`,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/AdminService.ts